import { Buffer } from 'buffer'

if (typeof (globalThis as { Buffer?: typeof Buffer }).Buffer === 'undefined') {
  ;(globalThis as { Buffer: typeof Buffer }).Buffer = Buffer
}
